export default "__VITE_ASSET__4da78dee__"